<template>
  <div class="team">
    <b-container class="mt-top text-left prl-outside">
	  <b-row class="top-text">{{$t('ourTeam')}}</b-row>
	  <p>{{$t('teamText')}}</p>
      <b-row class="p-0"
        v-for="(team, key) in teams" :key="key">
		  <b-col cols="12" class="mt-2 mb-2 fs25p">{{team.teamName}}</b-col>
		  <div v-for="(crewMember, ckey) in team.crew" :key="ckey" class="col-6 col-md-4 col-xl-2 mb-3">
		  	<img :src="require(`@/assets/img/team/${crewMember.pic}`)" class="w-100"/>
		  	<div class="mt-2 w-100 fs07">
		  		<ul class="list-group p-0 m-0">
				  <li class="list-group-item p-0 m-0 cursord fw700 fs12"><b>{{crewMember.name}}</b></li>
				  <li class="list-group-item p-0 m-0 mb-1 cursord fs11" v-if="crewMember.title">{{crewMember.title}}</li>
				  <li class="list-group-item p-0 m-0 inline cursord" v-if="crewMember.phone">T: {{crewMember.phone}}</li>
				  <li class="list-group-item p-0 m-0 inline cursord" v-if="crewMember.mobile">M: {{crewMember.mobile}}</li>
				  <li class="list-group-item p-0 m-0 inline" v-if="crewMember.email"><a :href="`mailto:${crewMember.email}`">E: {{crewMember.email}}</a></li>
				</ul>
			</div>
		  </div>
      </b-row>
    </b-container>
    <div class="big-text">{{$t('team')}}</div>
  </div>
</template>

<script>
export default {
  name: 'Team',
  data () {
    return {
    	teams: [
    			{
		    		teamName: this.$t('management'),
		    		crew: [
		    			{
		    				name: 'Helmut Raggam',
		    				pic: 'Raggam Helmut.jpg',
		    				title: this.$t('managdir'),
		    				phone: '+43(0) 3477 34 45 5',
		    				mobile: '+43 (0) 664 33 57 013',
		    				email: 'helmut.raggam@gera.at'
		    			},
		    			{
		    				name: 'Herbert Raggam, MSc',
		    				pic: 'Raggam Herbert.jpg',
		    				title: this.$t('managsig'),
		    				phone: '+43(0) 3477 34 45 1',
		    				mobile: '',
		    				email: 'herbert.raggam@gera.at'
		    			},
		    			{
		    				name: 'Rudolf Grabner',
		    				pic: 'Grabner Rudolf.jpg',
		    				title: this.$t('managsig'),
		    				phone: '+43(0) 3477 34 45 3',
		    				mobile: '+43 (0) 664 44 36 492',
		    				email: 'rudolf.grabner@gera.at'
		    			},
		    			{
		    				name: 'Michael Lechner',
		    				pic: 'Lechner Michael.jpg',
		    				title: this.$t('managsig'),
		    				phone: '+43 676 72 22 747',
		    				mobile: '+49 171 74 78 718',
		    				email: 'michael.lechner@gera.at'
		    			}
		    		]
		    	},
    			{
		    		teamName: this.$t('project'),
		    		crew: [
		    			{
		    				name: 'Josef Schreiber',
		    				pic: 'Schreiber Josef.jpg',
		    				title: this.$t('projectman')
						},
		    			{
		    				name: 'Franz Kirbisser',
		    				pic: 'Kürbisser Franz.jpg',
		    				title: this.$t('projectman')
		    			},
		    			{
		    				name: 'Horst Blühwald',
		    				pic: 'Blühwald Horst.jpg',
		    				title: this.$t('projectinst')
		    			},
/*		    			{
		    				name: 'Winfried Trummer',
		    				pic: 'Trummer Winfried.jpg',
		    				title: this.$t('projectinst')
						},*/
/*
		    			{
		    				name: 'Alex Bradac',
		    				pic: 'GE_2020_Platzhalter_Personal_Montage.png',
		    				title: 'Montageleiter'
						},
*/
		    			{
		    				name: 'Manfred Wischenbart',
		    				pic: 'Wischenbart Manfred.jpg',
		    				title: this.$t('projectinst')
		    			},
		    			{
		    				name: 'Gerhard Legenstein',
		    				pic: 'Legenstein Gerhard.jpg',
		    				title: this.$t('projectinst')
						},
/*
		    			{
		    				name: 'Bernd Schweiger',
		    				pic: 'GE_2020_Platzhalter_Personal_Montage.png',
		    				title: 'Montageleiter'
						},
*/
		    			{
		    				name: 'Johannes Zacharias',
		    				pic: 'Zacharias Johannes.jpg',
		    				title: this.$t('projectinst')
		    			},
/*
		    			{
		    				name: 'Helmut Schrott',
		    				pic: 'Schrott Helmut.jpg',
		    				title: this.$t('projectinst')
						},
		    			{
		    				name: 'Franz Gerster',
		    				pic: 'GE_2020_Platzhalter_Personal_Montage.png',
		    				title: 'Montageleiter'
						},
*/
		    			{
		    				name: 'Christopher Krammer',
		    				pic: 'Krammer Christopher.jpg',
		    				title: this.$t('projectinst')
		    			},
/*
		    			{
		    				name: 'Markus Kothgasser',
		    				pic: 'GE_2020_Platzhalter_Personal_Montage.png',
		    				title: this.$t('projectinst')
						},
*/
		    			{
		    				name: 'Heinz Rath',
		    				pic: 'Rath Heinz.jpg',
		    				title: this.$t('projectinst')
						},
		    			{
		    				name: 'Josef Baumgartner',
		    				pic: 'Baumgartner Josef.jpg',
		    				title: this.$t('projectinst')
						},
/*		    			{
	    				name: 'Lukas Brandstätter',
		    				pic: 'Brandstätter Lukas.jpg',
		    				title: this.$t('projectinst')
						},*/
		    			{
		    				name: 'Markus Ifkovits',
		    				pic: 'Ifkovits Markus.jpg',
		    				title: this.$t('projectinst')
						},
/*		    			{
		    				name: 'Dusan Krapez',
		    				pic: 'Krapez Dusan.jpg',
		    				title: this.$t('projectinst')
						},*/
/*
		    			{
		    				name: 'Nikolaus Kreuzer',
		    				pic: 'Kreuzer Nikolaus.jpg',
		    				title: this.$t('projectinst')
						},
*/
		    			{
		    				name: 'Martin Sudi',
		    				pic: 'Sudy Martin.jpg',
		    				title: this.$t('projectinst')
						}
/*
		    			{
		    				name: 'Herwig Zechner',
		    				pic: 'GE_2020_Platzhalter_Personal_Montage.png',
		    				title: 'Montageleiter'
						}
*/
		    		]
		    	}
    		]
    }
  },
	methods: {
		onSlideStart (slide) {
		this.sliding = true
		},
		onSlideEnd (slide) {
		this.sliding = false
		}
	},
}
</script>
<style scoped>
  a, a:hover { text-decoration:underline; color: #212529; }
</style>
<i18n>
	{
		"de": {
			"ourTeam": "Unser Team",
			"team": "Team",
			"teamText": "Alle unsere Montagetischler und Mitarbeiter konnten ihre Berufung zu ihrem Beruf machen, deshalb ist die höchste Qualität unseres Handwerkes gerade gut genug für uns. Dem Streben nach Perfektion ist es zu verdanken, dass wir ständig neue Herausforderungen suchen und diese auch mit größter Sorgfalt umsetzen.",
			"management": "Geschäftsführung",
			"managdir": "Geschäftsführer",
			"managsig": "Prokurist",
			"project": "Projekt- und Montageleiter",
			"projectman": "Projektleiter",
			"projectinst": "Montageleiter"
		},
		"en": {
			"ourTeam": "Our Team",
			"team": "Team",
			"teamText": "All of our employees have been able to make their calling into their profession which is why nothing but the highest quality is good enough for us. Our striving for perfection comes from the fact that we are always looking for new challenges which we handle with the greatest amount of care.",
			"management": "Management",
			"managdir": "Managing director",
			"managsig": "Authorised signatory",
			"project": "Project and installation managers",
			"projectman": "Project manager",
			"projectinst": "Installation manager"
		}
	}
</i18n>
